import Vue from "vue";
import _ from "lodash";
import API from "@/api/index";
import DSRCmessage from "@/helpers/DSRCmessage.js";
import moment from "moment";
import TFMService from "@/api/service";

const MODULE_NAME = "rsu";

const MUTATION_TYPES = {
	ADD_RSU: "ADD_RSU",
	CLEAR_RSUS: "CLEAR_RSUS",
	SET_MANAGE_INFO: "SET_MANAGE_INFO",
	UPDATE_RSU_DATA: "UPDATE_RSU_DATA",
	CLEAR_TESTED_RSUS: "CLEAR_RSUS_TESTS_LIST",
	ADD_TO_RSU_TEST_LIST: "ADD_TO_RSU_TEST_LIST",
	SET_RSU_TESTS: "SET_RSU_TESTS",
	GET_TESTED_RSU_DEVICE_ID: "GET_TESTED_RSU_DEVICE_ID"
};

const ACTION_TYPES = {
	FETCH_RSU_METADATA: "FETCH_METADATA",
	FETCH_RSU_MANAGE_INFO: "FETCH_MANAGE_INFO",
	FETCH_RSU_BROADCASTING_MESSAGES: "FETCH_BROADCASTING_MESSAGES",
	FETCH_RSU_TIMS: "FETCH_TIMS",
	FETCH_RSU_MAP_STATUS: "FETCH_MAP_STATUS",
	FETCH_RSU_RADIO_NEIGHBORS: "FETCH_RSU_RADIO_NEIGHBORS",
	FETCH_ALL_DEVICES: "FETCH_ALL_DEVICES",
	FETCH_ALL_DSRC_FLAGS: "FETCH_ALL_DSRC_FLAGS",
	FETCH_RSUS: "FETCH_RSUS",
	GET_RSU_LIST_WITH_COMPLETE_TEST: "GET_RSU_LIST_WITH_COMPLETE_TEST",
	GET_TEST_LIST_BY_RSU: "GET_TEST_LIST_BY_RSU"
};

export default {
	MODULE_NAME,
	MUTATION_TYPES,
	ACTION_TYPES,
	namespaced: true,

	state: {
		rsus: {},
		devices: {},
		manageInfo: {},
		testedRSUDeviceIds: [],
		tests: {}
	},

	mutations: {
		[MUTATION_TYPES.ADD_RSU](state, payload) {
			const putDevice = r => {
				// create defaults
				const device = Object.assign(
					{
						$deviceTypeId: 1,
						tims: null,
						mapStatus: null,
						firmwareVersion: null,
						locationTypeDescription: null,
						locationDescriptionId: null,
						manufacturerName: null,
						serialNumber: null,
						manageInfo: null
					},
					r
				);
				return Vue.set(state.devices, device.deviceId, device);
			};
			if (_.isEmpty(payload)) return;
			if (!Array.isArray(payload)) {
				payload = [payload];
			}
			payload.map(putDevice);
		},

		[MUTATION_TYPES.SET_MANAGE_INFO](state, { id, data }) {
			Vue.set(state.manageInfo, id, data);
			// Vue.set(state.devices[id], "manageInfo", data);
		},

		[MUTATION_TYPES.UPDATE_RSU_DATA](state, { index, data }) {
			if (state.devices[index]) {
				Vue.set(
					state.devices,
					index,
					Object.assign(state.devices[index], data)
				);
			}
		},

		[MUTATION_TYPES.CLEAR_RSUS](state) {
			Vue.set(state, "devices", {});
		},

		//Array of tests by rsuId
		[MUTATION_TYPES.SET_RSU_TESTS](state, { deviceId, rows }) {
			Vue.set(state.tests, deviceId, rows);
		},

		//Array of tested RSUs
		[MUTATION_TYPES.ADD_TO_RSU_TEST_LIST](state, payload) {
			if (_.isEmpty(payload)) return;
			const putRSU = rsu => {
				return rsu.deviceId
					? Vue.set(state.rsus, rsu.deviceId, rsu)
					: console.error(
							new Error("ADD_TO_RSU_TEST_LIST: Invalid rsu object.")
					  );
			};
			Vue.set(
				state,
				"testedRSUDeviceIds",
				payload.map(rsu => rsu.deviceId)
			);
			payload.map(putRSU);
		}
	},

	actions: {
		[ACTION_TYPES.FETCH_RSU_TIMS](context, { id }) {
			return new Promise((resolve, reject) => {
				const index = context.getters.indexByIdentifier(id);
				if (index === -1) {
					return reject(
						`Tried to fetch RSU TIMs for RSU with device ID ${id} but it didn't exist in the state (yet?).`
					);
				}
				API.getWithParamsJson(
					API.ENDPOINTS.GET_ALL_TIMS_AND_METADATA_BY_DEVICE_ID,
					{
						deviceId: id
					}
				)
					.then(json => {
						const tims = _.filter(json, row => {
							return row.tim.deviceId == id && row.tim.isActive;
						});
						context.commit(MUTATION_TYPES.UPDATE_RSU_DATA, {
							index: context.getters.indexByIdentifier(id),
							data: { tims }
						});
						resolve(tims);
					})
					.catch(err => {
						console.error(err);
						reject(err);
					});
			});
		},

		async [ACTION_TYPES.FETCH_RSU_MANAGE_INFO](context, { id }) {
			const data = await TFMService.getRSUManageInfo(id);
			context.commit(MUTATION_TYPES.SET_MANAGE_INFO, { id, data });
		},

		[ACTION_TYPES.FETCH_RSU_MAP_STATUS](context, { id }) {
			return new Promise((resolve, reject) => {
				const index = context.getters.indexByIdentifier(id);
				if (index === -1) {
					return reject(
						`Tried to fetch RSU MAP status for RSU with device ID ${id} but it didn't exist in the state (yet?).`
					);
				}
				const data = { mapStatus: false };
				const intersectionId = context.state.devices[index].intersectionId;
				if (!intersectionId) {
					context.commit(MUTATION_TYPES.UPDATE_RSU_DATA, { index, data });
					return reject(data);
				}
				const error = err => {
					context.commit(MUTATION_TYPES.UPDATE_RSU_DATA, { index, data });
					console.error(err);
					reject(err);
				};
				API.getWithParamsJson(
					API.ENDPOINTS.GET_MAP_MESSAGE_BY_INTERSECTION_ID, //GET_MAP_ACTIVE_STATUS_BY_INTERSECTION_ID,
					{
						intersectionId
					},
					{},
					error
				)
					.then(json => {
						context.commit(MUTATION_TYPES.UPDATE_RSU_DATA, {
							index,
							data: { mapStatus: json }
						});
						resolve(json);
					})
					.catch(error);
			});
		},

		[ACTION_TYPES.FETCH_RSU_BROADCASTING_MESSAGES](context, { id }) {
			return new Promise((resolve, reject) => {
				console.warn("RSU Broadcasting Messages has been deprecated.");
				const index = context.getters.indexByIdentifier(id);
				if (index === -1) {
					return reject(
						`Tried to fetch RSU broadcasting messages for RSU with device ID ${id} but it didn't exist in the state (yet?).`
					);
				}
				const data = { messages: [] };
				const error = err => {
					context.commit(MUTATION_TYPES.UPDATE_RSU_DATA, { index, data });
					console.error(err);
					reject(err);
				};
				API.getWithParamsJson(
					API.ENDPOINTS.GET_MESSAGES_BROADCAST_BY_DEVICE,
					{
						deviceId: id
					},
					{},
					error
				)
					.then(json => {
						context.commit(MUTATION_TYPES.UPDATE_RSU_DATA, {
							index,
							data: { messages: json }
						});
						resolve(json);
					})
					.catch(error);
			});
		},

		async [ACTION_TYPES.FETCH_RSU_METADATA](context, p) {
			const index = context.getters.indexByIdentifier(p.id);
			if (index === -1) {
				throw new Error(
					`Tried to fetch RSU metadata for RSU with device ID ${p.id} but it didn't exist in the state (yet?).`
				);
			}
			const data = {};
			data[ACTION_TYPES.FETCH_RSU_METADATA + "_start"] = _.now();
			context.commit(MUTATION_TYPES.UPDATE_RSU_DATA, { index, data });

			return await Promise.all([
				context
					.dispatch(ACTION_TYPES.FETCH_RSU_MAP_STATUS, p)
					.catch(err => console.warn("Found no MAP status for RSU:", p, err)),
				context
					.dispatch(ACTION_TYPES.FETCH_RSU_TIMS, p)
					.catch(err => console.warn("Found bad TIMs data for RSU", p, err)),
				/*context
					.dispatch(ACTION_TYPES.FETCH_RSU_BROADCASTING_MESSAGES, p)
					.catch(err =>
						console.warn("Found bad broadcasting messages for RSU", p, err)
					), */
				context
					.dispatch(ACTION_TYPES.FETCH_RSU_MANAGE_INFO, p)
					.catch(err => console.warn("Found bad manage info for RSU", p, err))
			]);
		},

		[ACTION_TYPES.FETCH_ALL_DSRC_FLAGS](context) {
			return new Promise((resolve, reject) => {
				API.getJson(API.ENDPOINTS.GET_RSU_DSRC_BY_USER)
					.then(json => {
						if (json.length === 1 && json[0].retCode == -1) {
							return reject(
								new Error(
									MODULE_NAME +
										"/" +
										ACTION_TYPES.FETCH_ALL_DSRC_FLAGS +
										" Error: " +
										(json[0].retMsg || "Invalid server response.")
								)
							);
						}
						if (!json.length) {
							return reject(
								new Error(
									MODULE_NAME +
										"/" +
										ACTION_TYPES.FETCH_ALL_DSRC_FLAGS +
										" Error: Empty Response"
								)
							);
						}
						_.each(json, rec => {
							try {
								const index = rec.deviceId;
								const dsrcFlags = { ...rec };
								delete dsrcFlags.deviceId;
								context.commit(MUTATION_TYPES.UPDATE_RSU_DATA, {
									index,
									data: { dsrcFlags }
								});
							} catch (e) {
								console.warn(
									MODULE_NAME +
										"/" +
										ACTION_TYPES.FETCH_ALL_DSRC_FLAGS +
										" Error: " +
										e.message +
										" record: " +
										JSON.stringify(rec)
								);
							}
						});
						resolve();
					})
					.catch(err => {
						console.error(err);
						reject(err);
					});
			});
		},

		[ACTION_TYPES.FETCH_RSUS](context) {
			return new Promise((resolve, reject) => {
				API.getJson(API.ENDPOINTS.GET_RSU_BY_USER)
					.then(json => {
						if (json) {
							if (json.length === 1 && json[0].retCode == -1) {
								throw new Error(
									"FETCH_RSUs Error: " +
										(json[0].retMsg || "Invalid server response.")
								);
							}
							context.commit(MUTATION_TYPES.CLEAR_RSUS);
							context.commit(MUTATION_TYPES.ADD_RSU, json);
						}
						resolve();
					})
					.catch(err => {
						console.error(err);
						reject(err);
					});
			});
		},
		[ACTION_TYPES.FETCH_RSU_RADIO_NEIGHBORS](context, { rsuId, deviceId }) {
			rsuId = rsuId || deviceId;
			return API.getWithParamsJson(
				API.ENDPOINTS.GET_RSU_RADIO_NEIGHBORS_BY_USER,
				{ rsuId },
				{},
				e => {
					throw e;
				}
			)
				.catch(err => {
					console.error(err);
					return { rows: [] };
				})
				.then(({ rows }) => {
					context.commit(MUTATION_TYPES.UPDATE_RSU_DATA, {
						index: rsuId,
						data: { radioNeighborIds: rows.map(r => r.deviceId) }
					});
				});
		},

		[ACTION_TYPES.FETCH_ALL_DEVICES](context) {
			return context.dispatch(ACTION_TYPES.FETCH_RSUS);
		},

		[ACTION_TYPES.GET_TEST_LIST_BY_RSU](
			context,
			{ deviceId, startDate, endDate, testResult, ownerId, operatorId }
		) {
			return API.getWithParamsJson(
				API.ENDPOINTS.GET_TEST_LIST_BY_RSU,
				{
					deviceId,
					startDate,
					endDate,
					testResult,
					ownerId,
					operatorId
				},
				{},
				e => {
					throw e;
				}
			)
				.catch(err => {
					console.error(err);
					return [];
				})
				.then(rows => {
					// If we searched by deviceId, then the only results we got back
					// are for that device, so just assign all rows.
					if (deviceId) {
						context.commit(MUTATION_TYPES.SET_RSU_TESTS, { deviceId, rows });
						return;
					}
					// In case no deviceId is set we need to expect
					// results from any and all tested devices.
					_.each(context.state.testedRSUDeviceIds, id => {
						const results = rows.filter(row => row.deviceId == id);
						context.commit(MUTATION_TYPES.SET_RSU_TESTS, {
							deviceId: id,
							rows: results
						});
					});
				});
		},

		//List of RSUs with completed tests
		[ACTION_TYPES.GET_RSU_LIST_WITH_COMPLETE_TEST](context) {
			return API.getWithParamsJson(
				API.ENDPOINTS.GET_RSU_LIST_WITH_COMPLETE_TEST,
				{},
				{},
				e => {
					throw e;
				}
			)
				.catch(e => {
					console.warn(e);
					return [];
				})
				.then(payload => {
					context.commit(MUTATION_TYPES.ADD_TO_RSU_TEST_LIST, payload);
					// payload.map(row =>
					// 	context.dispatch(ACTION_TYPES.GET_TEST_LIST_BY_RSU, row)
					// );
				});
		}
	},

	getters: {
		listOfTestsByRsu(state) {
			return state.tests;
		},

		testedRSUDeviceIds(state) {
			return state.testedRSUDeviceIds;
		},

		testedRSUs(state) {
			return state.testedRSUDeviceIds.map(deviceId => state.rsus[deviceId]);
		},

		allDevices(state) {
			return state.devices;
		},

		devicePosition() {
			return device => {
				if (device === null || device === void 0) return null;
				if (!("latitude" in device) || !("longitude" in device)) return null;
				return [device.latitude, device.longitude];
			};
		},
		DSRCmsgID() {
			return key => {
				const m = DSRCmessage.get(key);
				return m && m.id;
			};
		},

		indexByIdentifier(state) {
			return identifier => (state.devices[identifier] ? identifier : -1);
		},

		byIdentifier(state) {
			return identifier => {
				return state.devices[identifier];
			};
		},

		isManagableByID(state, getters) {
			return id => {
				const device = getters.byIdentifier(id);
				if (device && device.accessLevel)
					return device.accessLevel.toLowerCase() === "edit";
				return false;
			};
		},

		isVerifiableByID(state, getters) {
			return id => {
				const device = getters.byIdentifier(id);
				if (!device) return false;
				return (
					getters.isManagableByID(id) &&
					(device.deviceStatus == "Active" || device.deviceStatus == "Inactive")
				);
			};
		},

		shouldHaveType(state, getters) {
			return ({ rsuId, msgType }) => {
				var shouldHaveType = null;
				const rsu = getters.byIdentifier(rsuId);
				if (!(rsu && rsu.dsrcFlags)) return false;
				switch (msgType) {
					case "MAP":
						shouldHaveType = !!rsu.dsrcFlags.hasMAP;
						break;
					case "SPAT":
						shouldHaveType = !!rsu.dsrcFlags.hasSPAT || !!rsu.dsrcFlags.hasMAP; // For now, assume the presence of a MAP implies there should be a SPaT
						break;
					case "TIM":
						shouldHaveType = !!rsu.dsrcFlags.hasTIM;
						break;
					case "SSM":
						shouldHaveType = null; // This is an on-demand type, so the question of whether it "should" be present is not meaningful.
						break;
				}
				// console.log(
				// 	"shouldHaveType: RSU %d should have %o: %o",
				// 	rsuId,
				// 	msgType,
				// 	shouldHaveType
				// );
				return shouldHaveType;
			};
		},

		manageInfoByID(state) {
			return id => state.manageInfo[id];
			// return id => getters.byIdentifier(id).manageInfo;
		},

		radioNeighborIds(state) {
			return deviceId =>
				state.devices[deviceId] && state.devices[deviceId].radioNeighborIds;
		},

		statusMetadata(state, getters) {
			return identifier => {
				const rsu = getters.byIdentifier(identifier);

				const spatMessageEntry = _.find(rsu.messages, { messageType: "SPaT" });
				const mapMessageEntry = _.find(rsu.messages, { messageType: "MAP" });
				const timMessageEntry = _.find(rsu.messages, { messageType: "TIM" });

				const statusClass = f =>
					f === null ? {} : f ? { "is-success": true } : { "is-error": true };
				const statusTitle = f =>
					f ? "Connected and Transmitting" : "Connected but not Transmitting";
				const spatStatusText = f =>
					f === null ? "Loading..." : f ? "Online" : "Unknown";
				const mapStatusText = f =>
					f === null ? "Loading..." : f ? "Online" : "Unknown";
				const timStatusText = f =>
					f === null
						? "Loading..."
						: Array.isArray(f)
						? `${f.length} Message(s)`
						: "Offline";

				const mapIsActive =
					rsu.mapStatus === null
						? null
						: rsu.mapStatus
						? rsu.mapStatus.isActive
						: false;
				const tims = rsu.tims === null ? null : rsu.tims;

				return {
					spat: {
						class: statusClass(mapIsActive),
						title:
							statusTitle(mapIsActive) +
							` (${
								spatMessageEntry
									? moment(spatMessageEntry.msgTimestamp).fromNow()
									: "UNKNOWN"
							})`,
						displayText: spatStatusText(mapIsActive)
					},
					map: {
						class: statusClass(mapIsActive),
						title:
							statusTitle(mapIsActive) +
							` (${
								mapMessageEntry
									? moment(mapMessageEntry.msgTimestamp).fromNow()
									: "UNKNOWN"
							})`,
						displayText: mapStatusText(mapIsActive)
					},
					tim: {
						class: statusClass(tims),
						title:
							statusTitle(tims) +
							` (${
								timMessageEntry
									? moment(timMessageEntry.msgTimestamp).fromNow()
									: "UNKNOWN"
							})`,
						displayText: timStatusText(tims)
					}
				};
			};
		}
	}
};
